const Projects = [
  {
    id: 0,
    url: 'https://x-change.netlify.app/',
    imgUrl: 'img/projects/preview/xchange.png',
    title: 'XChange',
    description: 'Cryptocurrency platform: view all cryptocurrencies and their values in real time.',
    tags: [
      'Vue.js',
      'Tailwind',
      'CoinCap API',
    ],
  },
  {
    id: 0,
    url: 'https://www.npmjs.com/package/mediaplayer-plugins',
    imgUrl: 'img/projects/preview/mediaplayer.png',
    title: 'Mediaplayer Plugins ',
    description: 'NPM package, plugins that give extra functionalities to the video player.',
    tags: [
      'JavaScript',
      'TypeScript',
      'NPM',
    ],
  },
  {
    id: 0,
    url: null,
    imgUrl: 'img/projects/preview/ecologic-web.png',
    title: 'Eco-logic Web',
    description: 'Web Application, drip irrigation system: information of your plants, statistics, user control, and water your plants from anywhere.',
    tags: [
      'Angular',
      'Bootstrap',
      'Node.js',
      'API REST',
      'Firebase',
    ],
  },
  {
    id: 0,
    url: null,
    imgUrl: 'img/projects/preview/ecologic.png',
    title: 'Eco-logic Android',
    description: 'Android Application, drip irrigation system: information of your plants, statistics, user control, and water your plants from anywhere.',
    tags: [
      'Java',
      'Laravel',
      'API REST',
      'MySQL',
    ],
  },
  {
    id: 0,
    url: null,
    imgUrl: 'img/projects/preview/galvanic.png',
    title: 'Galvanic Therapy',
    description: 'Web Application, personal care products e-commerce.',
    tags: [
      'HTML',
      'CSS',
      'JavaScript',
      'JQuery',
      'PHP',
    ],
  },
];

export default Projects;
